import { useState } from 'react'
import { Tabs, Tab, KpiCard, Alert } from '@/components/ui'
import { Flame, Briefcase, CheckCircle2, SlidersHorizontal, BarChart3, Users, Clock, TrendingUp, AlertTriangle } from 'lucide-react'
import { Cola } from './Cola'
import { MiMesa } from './MiMesa'
import { Resueltos } from './Resueltos'
import { Reglas } from './Reglas'
import { Kpis } from './Kpis'

type TabKey = 'cola' | 'mesa' | 'resueltos' | 'reglas' | 'kpis'

export function HumanaPage() {
  const [tab, setTab] = useState<TabKey>('cola')

  return (
    <div className="space-y-5">
      <header>
        <div className="text-xs uppercase tracking-widest text-amber-600 font-semibold">WhatsApp · Gestión humana</div>
        <h1 className="font-display text-3xl text-navy-700 leading-tight">Agentes humanos</h1>
        <p className="text-sm text-slate-500 max-w-2xl mt-1">
          Casos donde la IA escaló: tono agresivo, planes custom, comprobantes rechazados, VIP. Agentes humanos resuelven con contexto completo.
        </p>
      </header>

      <div className="grid grid-cols-2 lg:grid-cols-5 gap-3">
        <KpiCard label="En cola ahora" value={<span>14 <span className="text-xs text-rose-600 font-semibold">(3 P1)</span></span>} sub="esperando asignación" icon={<Flame className="w-3.5 h-3.5" />} color="rose" />
        <KpiCard label="Mis asignados" value="3" sub="de 5 slots máx" icon={<Briefcase className="w-3.5 h-3.5" />} color="amber" />
        <KpiCard label="Tiempo prom espera" value="6 min" sub="meta < 5 min" icon={<Clock className="w-3.5 h-3.5" />} color="amber" />
        <KpiCard label="Resueltos hoy" value="28" sub="89% satisfecho" icon={<CheckCircle2 className="w-3.5 h-3.5" />} color="emerald" />
        <KpiCard label="Agentes activos" value="4/5" sub="en línea" icon={<Users className="w-3.5 h-3.5" />} />
      </div>

      <Alert variant="danger" title="SLA en riesgo">
        3 chats urgentes esperando más de 15 minutos. Priorizá P1 ya.
      </Alert>

      <Tabs value={tab} onChange={v => setTab(v as TabKey)} color="amber">
        <Tab value="cola" icon={<Flame className="w-4 h-4" />} badge={<span className="ml-1 bg-rose-500 text-white text-[9px] px-1.5 py-0.5 rounded-full">14</span>}>Cola</Tab>
        <Tab value="mesa" icon={<Briefcase className="w-4 h-4" />}>Mi mesa</Tab>
        <Tab value="resueltos" icon={<CheckCircle2 className="w-4 h-4" />}>Resueltos</Tab>
        <Tab value="reglas" icon={<SlidersHorizontal className="w-4 h-4" />}>Reglas</Tab>
        <Tab value="kpis" icon={<BarChart3 className="w-4 h-4" />}>KPIs equipo</Tab>
      </Tabs>

      <div className="view-transition">
        {tab === 'cola' && <Cola />}
        {tab === 'mesa' && <MiMesa />}
        {tab === 'resueltos' && <Resueltos />}
        {tab === 'reglas' && <Reglas />}
        {tab === 'kpis' && <Kpis />}
      </div>
    </div>
  )
}
